import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_33: FaireProductEntity = {
  token: "catalog_prod_prod-33",
  type: "product",
  name: "Candle Holder",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 73.15,
  msrpDollars: 182.88,
  sku: "PA0033",
  caseSize: 12,
  material: "Linen",
  collectionToken: "col_pattern-play",
  categoryTokens: ["catalog_cat_bath"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: true,
  inStock: true,
  stockLevel: 82,
  description: "Beautiful Pattern Play piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
